import React from 'react'
import ULogo from "../assets/footer_logo.png"
import { Link } from 'react-router-dom'

import { GrInstagram } from "react-icons/gr";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa6";


const Footer = () => {
    return (
        <footer className="text-white bg-[#1E252F] px-6 py-10">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start gap-8">

                {/* Left: Logo + Social Icons */}
                <div className="flex flex-col items-start space-y-14">
                    {/* Logo */}
                    <Link to="/">
                        <img src={ULogo} alt="u_logo" loading='lazy' className='h-20' />
                    </Link>

                    {/* Social Media Icons */}
                    <div className="flex items-center space-x-6">
                        <a href="https://www.instagram.com/tuberdelivery/" target='_blank' aria-label="Instagram" className='text-primary hover:text-white transition-all duration-300'>
                            <GrInstagram size={24} />
                        </a>
                        <a href="https://www.facebook.com/tuberaustralia/" target='_blank' aria-label="Facebook" className='text-primary hover:text-white duration-300'>
                            <FaFacebookF size={24} />
                        </a>
                        <a href="https://www.linkedin.com/company/tuber-australia/?originalSubdomain=au" target='_blank' aria-label="LinkedIn" className='text-primary hover:text-white transition-all duration-300'>
                            <FaLinkedinIn size={30} />
                        </a>
                    </div>
                </div>

                {/* Right: Buttons */}
                <div className="flex flex-col space-y-6">
                    <Link
                        to="/businesses"
                        className="bg-primary rounded-md px-6 py-[10px] font-semibold text-white hover:opacity-90 transition-all duration-300"
                    >
                        For Businesses
                    </Link>

                    <Link
                        to="/drivers"
                        className="bg-primary rounded-md px-6 py-[10px] font-semibold text-white hover:opacity-90 transition-all duration-300"
                    >
                        For Drivers
                    </Link>
                </div>
            </div>

        </footer>

    )
}

export default Footer